import { render, staticRenderFns } from "./detail-new.vue?vue&type=template&id=b099457c&scoped=true&"
import script from "./detail-new.vue?vue&type=script&lang=js&"
export * from "./detail-new.vue?vue&type=script&lang=js&"
import style0 from "./detail-new.vue?vue&type=style&index=0&id=b099457c&prod&scoped=true&lang=css&"
import style1 from "./detail-new.vue?vue&type=style&index=1&id=b099457c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b099457c",
  null
  
)

export default component.exports